import useOnMount from '@/hooks/useOnMount';
import { useSetIntercomIsVisible } from '@/queries/layout.queries';
import QuizletSellScreen from './components/sell/quizlet-sell-screen';
import { useQuizletControllerGetLatestResults } from '@/api/generated/quizlet/quizlet';
import useVisitorSession from '@/hooks/useVisitorSession';
import { VARS } from '@/app/components/ppra/components/common/constants';

export default function QuizletSellPage() {
  const setIntercomIsVisible = useSetIntercomIsVisible();
  const { sessionToken } = useVisitorSession();
  const { data: quizletResults } = useQuizletControllerGetLatestResults({
    query: { enabled: !!sessionToken },
  });

  // Hide intercom when the component mounts
  useOnMount(() => {
    setIntercomIsVisible.mutate(false);
    return () => {
      setIntercomIsVisible.mutate(true);
    };
  });

  // Prepare personalized messages with firstName if available
  const personalizedMessages = quizletResults?.personalizedMessages ? [...quizletResults.personalizedMessages] : undefined;
  if (quizletResults?.firstName && personalizedMessages && personalizedMessages.length > 0) {
    // Add personalized greeting as the first message
    personalizedMessages.unshift(`**Congratulations ${quizletResults.firstName}!** You are a great candidate for Catch.`);
  }

  // Always render the sell screen, even if quizletResults is undefined
  // The PersonalizedList component will handle displaying generic marketing messages if needed
  return (
    <QuizletSellScreen
      headline={undefined} // V1 uses default headline
      personalizedMessages={personalizedMessages}
      cancerInterestMessage={quizletResults?.cancerInterestMessage}
      ctaText={`Join for ${VARS.price.yearly}`}
    />
  );
}
